/* global $:false */
;(function () {
  'use strict'

  angular
    .module('admin.notification_history.edit', [])
    .controller('NotificationHistoryEditAdminCtrl', NotificationHistoryEditAdminCtrl)

  /** @ngInject */
  function NotificationHistoryEditAdminCtrl(
    $scope,
    $state,
    $stateParams,
    $timeout,
    NotificationsService,
    NotificationHistoryService,
    UsersService,
  ) {
    var vm = this
    vm.works = false
    vm.isChannel = true
    vm.isNumber = true
    vm.waitChannel = true
    vm.waitSet = true
    vm.channels = []
    vm.bundles = []
    vm.sets = []
    vm.isOpen = false
    vm.isEvent = $stateParams.event
    vm.isCreate = $stateParams.create

    var isDate = function (date) {
      return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
    }

    vm.openCalendar = function (e) {
      e.preventDefault()
      e.stopPropagation()

      vm.isOpen = true
    }

    NotificationHistoryService.get($stateParams.id).then(function (result) {
      vm.model = result.results
      var json = ''
      if (vm.isEvent && vm.isCreate === 'true') {
        var channelId = localStorage.getItem('channelId')
        var channelName = localStorage.getItem('channelName')
        var setId = localStorage.getItem('setId')
        var bundleId = localStorage.getItem('bundleId')
        json = { target: 'channels', k: 'b', group: 'all', s: bundleId, users: [channelId] }
      } else {
        json = JSON.parse(vm.model.to)
      }
      var target = json.target
      var users = json.users
      var concat = ''
      if (users !== undefined) {
        for (var i = 0; i < users.length; i++) {
          if (users.length === i + 1) {
            concat += users[i]
          } else {
            concat += users[i] + ','
          }
        }
      }

      $('#users').val(concat)
      $('#group').val(json.group)
      $('#target').val(target)
      $('#message').val(vm.model.txt)
      $('.collectible-target-channel').hide()
      $('.collectible-target-users').hide()

      if (target === 'users') {
        $('.collectible-target-users').show()
      } else if (target === 'channels') {
        $('.collectible-target-channel').show()
      }
      if (json.combo !== undefined) {
        vm.isNumber = false
        vm.isChannel = true
        $('#link').val(json.combo.k)
        NotificationsService.list().then(function (response) {
          vm.channels = response.result
          vm.channel = json.combo.channel
          NotificationsService.listSets(vm.channel).then(function (response) {
            vm.sets = response.results
            vm.bundles = []
            vm.waitSet = true
            vm.waitChannel = false
            vm.set = json.combo.set
            NotificationsService.listBundles(vm.set).then(function (response) {
              vm.bundles = []
              var bundles = response.results
              for (var i = 0; i < bundles.length; i++) {
                if (bundles[i].st === 1) {
                  var b = bundles[i]
                  b.t = b.id + ' - ' + b.t
                  vm.bundles.push(b)
                }
              }
              vm.waitSet = false
              vm.bundle = json.combo.bundle
              if (target === 'channels') {
                $.each(vm.channels, function (index, item) {
                  var isTrue = false
                  if (users !== undefined) {
                    for (var i = 0; i < users.length; i++) {
                      if (parseInt(users[i]) === item.id) {
                        isTrue = true
                        break
                      }
                    }
                  }

                  if (isTrue) {
                    $('#form-group-channels').append(
                      '<div class="col-sm-4"><div class="checkbox"><label><input type="checkbox" value="' +
                        item.id +
                        '" checked>' +
                        item.st +
                        '</label></div>',
                    )
                  } else {
                    $('#form-group-channels').append(
                      '<div class="col-sm-4"><div class="checkbox"><label><input type="checkbox" value="' +
                        item.id +
                        '">' +
                        item.st +
                        '</label></div>',
                    )
                  }
                })

                if (vm.isCreate === 'true') {
                  var chh = ''
                  $('#form-group-channels input:checked').each(function () {
                    users.push($(this).val())
                    chh += $(this).parent().text() + ','
                  })

                  json.channels = chh
                  NotificationHistoryService.update($stateParams.id, {
                    dl: 'bundles/' + bundleId,
                    to: JSON.stringify(json),
                  }).then(function () {})
                }
              }
            })
          })
        })
      } else {
        NotificationsService.list().then(
          function (response) {
            vm.channels = response.result
            $.each(response.result, function (index, item) {
              var isTrue = false
              if (users !== undefined) {
                for (var i = 0; i < users.length; i++) {
                  if (parseInt(users[i]) === item.id) {
                    isTrue = true
                    break
                  }
                }
              }

              if (isTrue) {
                $('#form-group-channels').append(
                  '<div class="col-sm-4"><div class="checkbox"><label><input type="checkbox" value="' +
                    item.id +
                    '" checked>' +
                    item.st +
                    '</label></div>',
                )
              } else {
                $('#form-group-channels').append(
                  '<div class="col-sm-4"><div class="checkbox"><label><input type="checkbox" value="' +
                    item.id +
                    '">' +
                    item.st +
                    '</label></div>',
                )
              }
            })

            if (vm.isCreate === 'true') {
              var chh = ''
              $('#form-group-channels input:checked').each(function () {
                users.push($(this).val())
                chh += $(this).parent().text() + ','
              })

              json.channels = chh
              NotificationHistoryService.update($stateParams.id, {
                dl: 'bundles/' + bundleId,
                to: JSON.stringify(json),
              }).then(function () {})
            }
          },
          function () {
            swal('Problem loading channels!', '', 'error')
          },
        )

        $('#link').val(json.k)
        $('#number').val(json.s)
        vm.isNumber = true
        vm.isChannel = false
      }

      if (vm.isCreate === 'false') {
        if (vm.model['ts-p'] !== undefined && vm.model['ts-p'] !== 0) {
          vm.model['ts-p'] = vm.model['ts-p']
            .toString()
            .substring(0, vm.model['ts-p'].toString().length - 3)
          vm.model['ts-p'] = new Date(parseInt(vm.model['ts-p']))
          vm.data1 = angular.copy(vm.model['ts-p'])
        }
      } else if (vm.isCreate === undefined) {
        if (vm.model['ts-p'] !== undefined && vm.model['ts-p'] !== 0) {
          vm.model['ts-p'] = vm.model['ts-p']
            .toString()
            .substring(0, vm.model['ts-p'].toString().length - 3)
          vm.model['ts-p'] = new Date(parseInt(vm.model['ts-p']))
          vm.data1 = angular.copy(vm.model['ts-p'])
        }
      } else {
        vm.model['ts-p'] = null
        vm.data1 = null
      }
    })

    var watch = $scope.$watch('vm.channel', function (newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }

      if (newVal === null) {
        return
      }

      NotificationsService.listSets(newVal).then(function (response) {
        vm.sets = response.results
        vm.bundles = []
        vm.waitSet = true
        vm.waitChannel = false
      })
    })

    var watch1 = $scope.$watch('vm.set', function (newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }

      if (newVal === null) {
        return
      }

      NotificationsService.listBundles(newVal).then(function (response) {
        vm.bundles = []
        var bundles = response.results
        for (var i = 0; i < bundles.length; i++) {
          if (bundles[i].st === 1) {
            var b = bundles[i]
            b.t = b.id + ' - ' + b.t
            vm.bundles.push(b)
          }
        }
        vm.waitSet = false
      })
    })

    $scope.$on('$destroy', function () {
      watch()
      watch1()
    })

    $('#target').on('change', function () {
      $('.collectible-target-channel').hide()
      $('.collectible-target-users').hide()

      if (this.value === 'users') {
        $('.collectible-target-users').show()
        $('#users').val('')
      } else if (this.value === 'channels') {
        $('.collectible-target-channel').show()
      } else {
      }
    })

    $('#link').on('change', function () {
      if (this.value === 'bs') {
        vm.channel = null
        vm.set = null
        vm.bundle = null
        vm.isChannel = true
        vm.isNumber = false
      } else {
        vm.isChannel = false
        vm.isNumber = true
        $('#number').val('')
      }

      $scope.$apply()
    })

    $('#btnSubmit').on('click', function () {
      vm.works = true
      $('#btnSubmit').hide()
      var target = $('#target').val()
      var message = $('#message').val().trim()
      var group = $('#group').val()
      var k = $('#link').val()
      var s
      var combo = {}

      if (message.length < 15) {
        swal('Message must contain at least 15 characters.', '', 'error')
        vm.works = false
        $('#btnSubmit').show()
        return
      }

      if (k === undefined || k === '') {
        swal('Need select deep link.', '', 'error')
        vm.works = false
        $('#btnSubmit').show()
        return
      }

      var link = $('#link').val()
      if (link === 'bs') {
        if (vm.channel === undefined || vm.channel === null) {
          swal('You need to select a channel!', '', 'error')
          vm.works = false
          $('#btnSubmit').show()
          return
        }
        if (vm.set === undefined || vm.set === null) {
          swal('You need to select a set!', '', 'error')
          vm.works = false
          $('#btnSubmit').show()
          return
        }
        if (vm.bundle === undefined || vm.bundle === null) {
          swal('You need to select a bundle!', '', 'error')
          vm.works = false
          $('#btnSubmit').show()
          return
        }
        combo = { k: 'bs', channel: vm.channel, set: vm.set, bundle: vm.bundle }
        s = vm.bundle.toString()
        k = 'b'
      } else {
        combo = undefined
        s = $('#number').val()
      }

      if (s === undefined || s === '') {
        swal('You need select number or combo box.', '', 'error')
        vm.works = false
        $('#btnSubmit').show()
        return
      }

      if (message !== '') {
        if (k !== '' && s !== '') {
          var data = { target: target, message: message, k: k, s: s }
        } else {
          var data = { target: target, message: message }
        }

        if (group !== '') {
          data['group'] = group
        }

        var users = []
        var channels = ''
        if (target === 'users') {
          if ($('#users').val() === '') {
            swal('You need to select a Specific Users!', '', 'error')
            vm.works = false
            $('#btnSubmit').show()
            return
          }
          var users = $('#users').val().replace(/\s/g, '').split(',')
          data['users'] = users
        } else if (target === 'channels') {
          $('#form-group-channels input:checked').each(function () {
            users.push($(this).val())
            channels += $(this).parent().text() + ','
          })
          data['users'] = users

          if (channels === '') {
            swal('Choose a Channel.', '', 'error')
            vm.works = false
            $('#btnSubmit').show()
            return
          }
        }

        $('#loaderBlock').show()

        var deepName
        switch (link) {
          case 'u':
            deepName = 'users/'
            break
          case 'b':
            deepName = 'bundles/'
            break
          case 'bs':
            deepName = 'bundlessplunge/'
            break
          case 's':
            deepName = 'sets/'
            break
          case 'ch':
            deepName = 'channels/'
            break
          case 'c':
            deepName = 'coinstores/'
            break
          case 'p':
            deepName = 'posts/'
            break
          case 'fb':
            deepName = 'freebundles/'
            break
        }

        data.combo = combo
        data.channels = channels
        var model = {
          txt: data.message,
          to: JSON.stringify(data),
          dl: deepName + data.s,
        }

        var date1
        if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
          if (isDate(vm.data1)) {
            model.st = 1
            var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
            model['ts-p'] = date1
          } else {
            swal('Date field invalid.', '', 'error')
            return
          }
        }

        if (vm.data1 === null) {
          model['ts-p'] = null
          model.st = 0
        }

        NotificationHistoryService.update($stateParams.id, model).then(function () {
          var msg = 'Updated with Success!'
          $('#resultMsg').text(msg)
          $('#alertResult').show()
          $('#btnSubmit').show()
          $('#loaderBlock').hide()
          vm.works = false

          if (vm.isEvent) {
            $state.go('admin.event')
            return
          }

          $timeout(function () {
            $state.go('admin.notification_history')
          }, 100)
        })
      } else {
        vm.works = false
        $('#btnSubmit').show()
      }
    })

    vm.cancel = function () {
      swal(
        {
          title: 'Cancel Edit Notifications',
          text: 'You really want to cancel ?',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            if (vm.isEvent) {
              $state.go('admin.event')
              return
            }
            $state.go('admin.notification_history')
          } else {
            return
          }
        },
      )
    }
  }
})()
